import packageApis from "../../api/package";

const state = {
    packages: {},
    activeTab: 'pass'
};

const getters = {};

const mutations = {
    SET_PACKAGES: (state, payload) => state.packages = payload,
    SET_ACTIVE_TAB: (state, payload) => state.activeTab = payload,
};

const actions = {
    async createPackage({commit}, data) {
        await packageApis.createPackage(data);
    },
    async getPackages({commit}, payload) {
        const {data} = await packageApis.getPackages(payload);
        await commit("SET_PACKAGES", data);
    },
    async cancelPackage({commit}, payload) {
        console.log(payload);
        const {data} = await packageApis.cancelPackages(payload);
    },
    async setActiveTab({commit}, data) {
        commit('SET_ACTIVE_TAB', data);
    }
};

export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};